import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import React from 'react';

import Container from '@glass/web/components/Layout/Container';
import SpinnerWithContainer from '@glass/web/components/Loading/SpinnerWithContainer';
import Paper from '@glass/web/components/base/Paper';
import {
  NAME_FIELD_V2,
  RESUME_V2_FIELD,
  TEMPLATE_FIELD_V2,
} from '@glass/web/modules/resumes/fieldKeys';
import resumeSize from '@glass/web/modules/resumes/templates/resumeSize';
import { MD } from '@glass/web/modules/theme/breakpointKeys';
import makeStyles from '@glass/web/modules/theme/makeStyles';

import AspectRatio from '@glass/shared/components/AspectRatio/AspectRatio';
import DynamicLoadingSpinnerWithContainer from '@glass/shared/components/Loading/DynamicLoadingSpinnerWithContainer';
import RandomResumeControlBar from '@glass/shared/components/Section/RandomResumeSection/RandomResumeControlBar';

const DynamicResumePreview = dynamic(
  () => import('@glass/shared/components/ResumeBuilder/ResumePreview'),
  {
    ssr: false,
    loading: DynamicLoadingSpinnerWithContainer,
  },
);

const useStyles = makeStyles()((theme) => ({
  settingsContainer: {
    overflow: 'auto',
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.grey[300],
  },
}));

function RandomResume({ onNextResume, loading, resume }) {
  const { classes } = useStyles();
  const templateSlug = resume?.[RESUME_V2_FIELD]?.[TEMPLATE_FIELD_V2]?.[NAME_FIELD_V2];

  return (
    <Container isNoXPadding isNoYPadding maxWidth={MD}>
      <RandomResumeControlBar
        className={classes.settingsContainer}
        templateSlug={templateSlug}
        onNextResume={onNextResume}
      />
      <div className={classes.container}>
        <Paper square variant="outlined">
          <AspectRatio height={resumeSize.height} width={resumeSize.width}>
            {!loading ? <DynamicResumePreview singlePage resume={resume} /> : null}
            {loading ? <SpinnerWithContainer minHeight="70vh" /> : null}
          </AspectRatio>
        </Paper>
      </div>
    </Container>
  );
}

RandomResume.propTypes = {
  loading: PropTypes.bool,
  onNextResume: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  resume: PropTypes.object,
};

export default React.memo(RandomResume);
